import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButtonVariant } from '../../Buttons/ContainedButton'
import { TextButtonVariant } from '../../Buttons/TextButton'
import ConfirmWithButtonsModal from '../ConfirmWithButtonsModal'

interface DeletePlaylistConfirmationModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  label: string
  confirmationMessage: string
}

const DeletePlaylistConfirmationModal: React.FC<DeletePlaylistConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  label,
  confirmationMessage
}) => {
  const { t } = useTranslation()
  return (
    <ConfirmWithButtonsModal
      isOpen={isOpen}
      title={t(
        'DeletePlaylistConfirmationModal.DeleteModal.Title',
        `Delete {{label}}`,
        { label: label }
      )}
      question={t(
        'DeletePlaylistConfirmationModal.DeleteModal.Question',
        `{{confirmationMessage}} ?`,
        { confirmationMessage: confirmationMessage }
      )}
      questionProps={{ variant: 'body1', align: 'center' }}
      confirmVariant={ContainedButtonVariant.YesDelete}
      cancelVariant={TextButtonVariant.NoCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default DeletePlaylistConfirmationModal
